import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Blog.css";

const BlogCard = ({ id, title, content }) => {
  const navigate = useNavigate();
  const extract = content.slice(0, 100);

  return (
    <article className="blog-card" aria-label={`Blog post ${title}`}>
      <img
        src={`/images/${id}.webp`}
        width="200px"
        height="200px"
        alt="Article blog"
      />
      <h2>{title}</h2>
      <p>{extract}...</p>
      <button className="leerMas" onClick={() => navigate(`/blog/${id}`)}>
        Read more...
      </button>
    </article>
  );
};

export default BlogCard;
